<template>
    <transition name="fade">
        <div id="Unbind" v-if="IsShow == true">
            <div class="background"></div>
            <div class="model">
                <img src="@/assets/images/mealCard/unbind.png" alt="">
                <p class="text">解绑之后，饭卡将不可使用，是否解绑？</p>
                <div class="footer">
                    <div @click="closeModel(cancel=false)"><p>取消</p></div>
                    <div @click="unbind"><p>解绑</p></div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
export default {
    props: ["IsShow"],
    data() {
        return {
            isOpen: this.IsShow,//避免更改props里的值，出现报错/警告
        };
    },
    methods: {
        // 把更改后的值提交给父组件
        closeModel(cancel) {
            this.isOpen = cancel;
            this.$emit("setRes", this.isOpen);
        },
        // 解绑
        unbind() {
           this.closeModel()
           this.$emit("inTiePhone");
        }
    }
};
</script>
<style lang="scss" scoped>
@import "~@/scss/libs.scss";
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
#Unbind {
    @include pos-f(0, 0, 0, 0);
    .background {
        @include mask-container($opacity: 60);
        z-index: 50;
    }
    .model {
        width: px2rem(578);
        padding: px2rem(30);
        @include transform-center;
        z-index: 61;
        background: white;
        border-radius: px2rem(10);
        text-align: center;
        img {
            @include square(328);
        }
        .text {
            font-size: px2rem(28);
            color: $grayCyan;
            padding-top: px2rem(10);
        }
        .footer {
            padding-top: px2rem(28);
            @include dis-flex(center, space-between);
            &> div {
                width: 100%;
                height: px2rem(78);
                &> p {
                    width: px2rem(250);
                    line-height: px2rem(78);
                    border: px2rem(1) solid $gray;
                    border-radius: px2rem(10);
                    font-size: px2rem(30);
                    color: $gray;
                }
                &:last-child p {
                    float: right;
                    background: $cyan;
                    color: white;
                    border: px2rem(1) solid $cyan;
                }
            }
        }
    }
}
</style>

